let frameRateKey = 'frameRate';
let audioTracksKey = 'audioTracks';
let camsKey = 'cams';
let tierListKey = 'tierList';
let daysKey = 'days';
let hoursKey = 'hours';
let minutesKey = 'minutes';
let modeKey = 'mode';
let storageUnitsKey = 'storageUnits';
let storageResultKey = 'storageResult';
let availableModesKey = 'availableMode';
let availableModesOptionsKey = 'availableModesOptions';
let interfaceTypeKey = 'interfaceType';
let speedUnitsKey = 'speedUnits';
let modeTransferTimeKey = 'modeTransferTime';
let availableModesOptionsTransferTimeKey = 'availableModesOptionsTransferTime';
let useCustomStorageSizeKey = 'useCustomStorageSize';
let customStorageSizeKey = 'customStorageSize';
let customStorageSizeUnitsKey = 'customStorageSizeUnits';

function getValueFromLocalStorage(key, defaultValue) {
  if (localStorage) {
    try {
      if (localStorage.hasOwnProperty(key)) return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.log(e);
    }
  }
  return defaultValue;
}

function saveValueToLocalStorage(key, value) {
  if (localStorage) {
    localStorage.setItem(key, JSON.stringify(value));
  }
}

export function getFrameRateFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(frameRateKey, defaultValue);
}

export function saveFrameRateToLocalStorage(value) {
  saveValueToLocalStorage(frameRateKey, value);
}

export function getAudioTracksFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(audioTracksKey, defaultValue);
}

export function saveAudioTracksToLocalStorage(value) {
  saveValueToLocalStorage(audioTracksKey, value);
}

export function getCamsFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(camsKey, defaultValue);
}

export function saveCamsToLocalStorage(value) {
  saveValueToLocalStorage(camsKey, value);
}

export function getTierListFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(tierListKey, defaultValue);
}

export function saveTierListToLocalStorage(value) {
  saveValueToLocalStorage(tierListKey, value);
}

export function getDaysFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(daysKey, defaultValue);
}

export function saveDaysToLocalStorage(value) {
  saveValueToLocalStorage(daysKey, value);
}

export function getHoursFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(hoursKey, defaultValue);
}

export function saveHoursToLocalStorage(value) {
  saveValueToLocalStorage(hoursKey, value);
}

export function getMinutesFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(minutesKey, defaultValue);
}

export function saveMinutesToLocalStorage(value) {
  saveValueToLocalStorage(minutesKey, value);
}

export function getModeFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(modeKey, defaultValue);
}

export function saveModeToLocalStorage(value) {
  saveValueToLocalStorage(modeKey, value);
}

export function getStorageUnitsFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(storageUnitsKey, defaultValue);
}

export function saveStorageUnitsToLocalStorage(value) {
  saveValueToLocalStorage(storageUnitsKey, value);
}

export function getStorageResultFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(storageResultKey, defaultValue);
}

export function saveStorageResultToLocalStorage(value) {
  saveValueToLocalStorage(storageResultKey, value);
}

export function getRecordModeFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(availableModesKey, defaultValue);
}

export function saveRecordModeToLocalStorage(value) {
  saveValueToLocalStorage(availableModesKey, value);
}

export function getAvailableModesOptionsFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(availableModesOptionsKey, defaultValue);
}

export function saveAvailableModesOptionsToLocalStorage(value) {
  saveValueToLocalStorage(availableModesOptionsKey, value);
}

export function getInterfaceTypeKeyFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(interfaceTypeKey, defaultValue);
}

export function saveInterfaceTypeToLocalStorage(value) {
  saveValueToLocalStorage(interfaceTypeKey, value);
}

export function getSpeedUnitsFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(speedUnitsKey, defaultValue);
}

export function saveSpeedUnitsToLocalStorage(value) {
  saveValueToLocalStorage(speedUnitsKey, value);
}

export function getModeTransferTimeFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(modeTransferTimeKey, defaultValue);
}

export function saveModeTransferTimeToLocalStorage(value) {
  saveValueToLocalStorage(modeTransferTimeKey, value);
}

export function getAvailableModesOptionsTransferTimeFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(availableModesOptionsTransferTimeKey, defaultValue);
}

export function saveAvailableModesOptionsTransferTimeToLocalStorage(value) {
  saveValueToLocalStorage(availableModesOptionsTransferTimeKey, value);
}

export function getUseCustomStorageSizeKeyFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(useCustomStorageSizeKey, defaultValue);
}

export function saveUseCustomStorageSizeKeyToLocalStorage(value) {
  saveValueToLocalStorage(useCustomStorageSizeKey, value);
}

export function getCustomStorageSizeKeyFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(customStorageSizeKey, defaultValue);
}

export function saveCustomStorageSizeKeyToLocalStorage(value) {
  saveValueToLocalStorage(customStorageSizeKey, value);
}

export function getCustomStorageSizeUnitsKeyFromLocalStorage(defaultValue) {
  return getValueFromLocalStorage(customStorageSizeUnitsKey, defaultValue);
}

export function saveCustomStorageSizeUnitsKeyToLocalStorage(value) {
  saveValueToLocalStorage(customStorageSizeUnitsKey, value);
}
